import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

type NotificationParams = {
	EndDate: string | null;
	LookupUser: string | null;
	StartDate: string | null;
	limit: number;
	page: number;
};

export type Notification = {
	Created_Date: string;
	Expiration_Date: string;
	Message: string;
	Must_Accept: boolean;
	NotificationVersion: string | null;
	Notification_ID: number;
	PrivacyPolicyMessage: string;
	PrivacyPolicyNotification_ID: number;
	Read_Date: string | null;
	Status: "Archived" | "Active" | "Inactive";
	Subject: string;
	TermsandConditionsMessage: string;
	TermsandConditionsNotification_ID: number;
	Type: "General" | string;
	Type_ID: number;
};

const initialState = new Array<Notification>();

export const {
	thunk: queryUserNotifications,
	slice: hiddenQueryUserNotificationsSlice,
	extraReducers: hiddenExtraReducers,
} = getThunkAndSlice<NotificationParams, Array<Notification>>({
	initialState,
	path: "/api/Notifications/QueryUserNotifications",
	method: "post",
	onAfterRequest: async (data) => {
		return [...data].sort((a, b) => {
			const dateA = a.Created_Date ? new Date(a.Created_Date).getTime() : 0;
			const dateB = b.Created_Date ? new Date(b.Created_Date).getTime() : 0;
			return dateB - dateA;
		});
	},
});

export const queryUserNotificationsSlice = createSlice({
	name: hiddenQueryUserNotificationsSlice.name,
	initialState: hiddenQueryUserNotificationsSlice.getInitialState(),
	reducers: {
		updateStatusToArchived: (state, action: PayloadAction<Array<number>>) => {
			state.data = state.data.map((x) =>
				action.payload.includes(x.Notification_ID) ? { ...x, Status: "Archived" as const } : x,
			);
		},
		updateReadStatus: (state, action: PayloadAction<{ ids: Array<number>; read: boolean }>) => {
			const { ids, read } = action.payload;
			const readDate = read ? new Date().toISOString() : null;
			state.data = state.data.map((x) => (ids.includes(x.Notification_ID) ? { ...x, Read_Date: readDate } : x));
		},
		updateStatusToActive: (state, action: PayloadAction<Array<number>>) => {
			state.data = state.data.map((x) =>
				action.payload.includes(x.Notification_ID) ? { ...x, Status: "Active" as const } : x,
			);
		},
	},
	extraReducers: hiddenExtraReducers,
});
